/**
 * OnlyOffice — hook da sessão de edição (Story E14.2.3).
 *
 * One-shot: busca a sessão quando o dialog abre. `retry:false` (não re-tentar
 * 503/403), `gcTime:0` (descarta ao fechar → reabrir pega token fresco; o token
 * tem TTL 1h no backend — lição E7.2.2 de não reusar token stale do cache),
 * `staleTime:Infinity` (não re-buscar enquanto aberto). A query só roda com o
 * dialog aberto e `documentId` presente.
 */
import { useQuery } from "@tanstack/react-query";

import { onlyofficeApi, type ModoDoEditor } from "@/services/onlyofficeApi";
import type { EditorSessionResponse } from "@/lib/onlyoffice-iframe-wrapper";

export function useEditorSession(
  documentId: string | null,
  open: boolean,
  modo: ModoDoEditor = "editar"
) {
  return useQuery<EditorSessionResponse>({
    // O modo entra na chave: a sessão de "visualizar" não pode servir a de "editar".
    queryKey: ["onlyoffice-session", documentId, modo],
    queryFn: () => onlyofficeApi.openEditorSession(documentId as string, modo),
    enabled: open && !!documentId,
    retry: false,
    gcTime: 0,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
